import React from "react";
import NewBanner from "./components/NewBanner";
import Areas from "./components/Areas";
import HomeListings from "./components/HomeListings";
import Testimonials from "./components/NewTestimonials";
import About from "./About";
import Listwithus from "./Listwithus";
import Featured from "./Featured";
import DynamicSeoPage from "../DynamicSeoPage";
const NewHome = () => {
  return (
    <div>
      <DynamicSeoPage
        page="home"
        defalut={"365 Luxury Homes - Find your Vacation Holiday in Dubai"}
      />
      <NewBanner />
      <Areas />
      <HomeListings />
      <Testimonials />
      <About />
      <Listwithus />
      <Featured />
    </div>
  );
};

export default NewHome;
